module.exports = __webpack_public_path__ + "static/img/fuwu-dayawan.ee6dba4.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/img/fuwu-dayawan.jpg
// module id = CVZP
// module chunks = 1